<template>
  <div class="max-w-4xl px-2 mx-auto mt-5">
    <div class="mb-2 text-xl font-medium text-center">
      Guide
    </div>
    <div class="p-4 bg-white border rounded-md shadow">
      <div class="grid max-w-md grid-cols-2 gap-2 mx-auto mt-3 mb-5">
        <button @click="tab = 'static'" :class="[tab == 'static' ? 'bg-indigo-500 text-white' : 'text-indigo-500']" class="px-2 transition duration-150 ease-in-out border border-indigo-500 rounded focus:outline-none hover:text-white hover:bg-indigo-600">Static HTML</button>      
        <button @click="tab = 'dynamic'" :class="[tab == 'dynamic' ? 'bg-indigo-500 text-white' : 'text-indigo-500']" class="px-2 transition duration-150 ease-in-out border border-indigo-500 rounded focus:outline-none hover:text-white hover:bg-indigo-600">Dynamically</button>      
      </div>

      <CollapseTransition>
        <div v-show="tab == 'static'">
          <static-html></static-html>
        </div>
      </CollapseTransition>

      <CollapseTransition>
        <div v-show="tab == 'dynamic'">
          <dynamic-html></dynamic-html>
        </div>
      </CollapseTransition>
      
    </div>
  </div>
</template>

<script>
  import StaticHtml from '../components/StaticHtml'
  import DynamicHtml from '../components/DynamicHtml'
  import hljs from 'highlight.js/lib/core'
  import xml from 'highlight.js/lib/languages/xml'
  import javascript from 'highlight.js/lib/languages/javascript'
  import 'highlight.js/styles/atom-one-dark.css'
  import { CollapseTransition } from 'vue2-transitions'
  hljs.registerLanguage('xml', xml)
  hljs.registerLanguage('javascript', javascript)

  export default {
    data() {
      return {
        tab: 'static'
      }
    },
    components: {
      StaticHtml,
      DynamicHtml,
      CollapseTransition
    },
    methods: {
      hljs() {
        document.querySelectorAll('pre code').forEach((block) => {
          hljs.highlightBlock(block);
        });
      }
    },
    mounted() {
      this.hljs()
    }
  }
</script>